export default __webpack_public_path__ + "static/media/mailwizz_logo.5bb7dd6d.png";